import { InMemoryObjectBase } from '../../../helpers/in-memory-object';
import { JSONUtilites } from '../../../helpers/JSONUtilites';
import { DiscountCoupon } from './discount-coupon';

export class InMemoryDiscountCoupons extends InMemoryObjectBase<DiscountCoupon> {

  protected get storeKeyName(): string {
    return 'in_memory_discount_coupons';
  }

  protected _createDemoItems(): DiscountCoupon[] {
    return [
      new DiscountCoupon('5 EUR discount', 5.00, true, '5OFF', false),
      new DiscountCoupon('10 EUR discount', 10.00, true, '10OFF', false),
      new DiscountCoupon('Sale 2018', 20.18, true, 'SUPER2018', false),
      new DiscountCoupon('13 EUR discount', 13.00, false, '13OFF', false),
      new DiscountCoupon('Free fly', 6.66, false, 'FREEFLY', false),
    ];
  }

  protected _FromJSON(json: string): DiscountCoupon[] {
    return JSONUtilites.arrayFromJSON<DiscountCoupon>(null, json, DiscountCoupon.createFromAny);
  }
}

